'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useShallow } from 'zustand/react/shallow';
import { useGlobalStore } from '@/stores/GlobalStore';

//* 혜택 오퍼월 임시 재정비 안내 — 재개 시 useAdpopcorn의 IS_BENEFIT_MAINTENANCE 가드와 함께 제거
export const BenefitMaintenanceModal = () => {
  const $ = _c(12);
  const [isShowBenefitMaintenanceModal, setIsShowBenefitMaintenanceModal] = useGlobalStore(useShallow(_temp));
  let t0;
  if ($[0] !== setIsShowBenefitMaintenanceModal) {
    t0 = () => {
      setIsShowBenefitMaintenanceModal(false);
    };
    $[0] = setIsShowBenefitMaintenanceModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClose = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="mb-8 font-700 text-Gray-900 typo-body1">잠시 재정비 중이에요</p>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="mb-12 text-center font-400 text-Gray-700 typo-body3">더 나은 혜택으로 돌아오기 위해{t2}혜택 서비스를 잠시 정비하고 있어요.<br /><b className="font-700">7월 24일 18시 ~ 19시</b></p>;
    t4 = <p className="mb-24 text-center font-400 text-Gray-500 typo-caption2">정비는 상황에 따라 조기 종료되거나 연장될 수 있어요.</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleClose) {
    t5 = <Button dimensions="H48" onClick={handleClose}>확인</Button>;
    $[6] = handleClose;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== handleClose || $[9] !== isShowBenefitMaintenanceModal || $[10] !== t5) {
    t6 = <Modal className="flex flex-col items-center" opened={isShowBenefitMaintenanceModal} onClose={handleClose}>{t1}{t3}{t4}{t5}</Modal>;
    $[8] = handleClose;
    $[9] = isShowBenefitMaintenanceModal;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp(state) {
  return [state.isShowBenefitMaintenanceModal, state.setIsShowBenefitMaintenanceModal] as const;
}